import React, { useState } from "react";
import ModalComponent from "../Modal";

const ComplaintComponent = ({
  data = [],
  onAssigned,
  complaintStatus,
  manageComplaint,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedComplaint, setSelectedComplaint] = useState(null);

  const openModal = (complaint) => {
    console.log("open Modal click", complaint); // Logging the clicked complaint
    setSelectedComplaint(complaint);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedComplaint(null);
  };

  const getHeaders = () => {
    switch (complaintStatus?.toLowerCase()) {
      case "open":
        return ["Name", "Mobile", "City", "Action", "Status"];
        
      case "assigned":
        return ["Name", "Mobile", "City", "Detail", "Manage"];
      case "closed":
        return ["Name", "Mobile", "City", "Detail", "Closed Status"];
      default:
        return ["Name", "Mobile", "City", "Detail", "Status"];
    }
  };

  const renderComplaintRow = (item) => {
    return (
      <>
        <td className="py-1.5 px-3 text-xs text-gray-800 border-t whitespace-nowrap">
          {item?.vendor.name}
        </td>
        <td className="py-1.5 px-3 text-xs text-gray-800 border-t whitespace-nowrap">
          {item?.vendor.phoneNumber}
        </td>
        <td className="py-1.5 px-3 text-xs text-gray-800 border-t whitespace-nowrap">
          {item?.vendor.city}
        </td>
        <td className="py-1.5 px-3 text-xs text-gray-800 border-t whitespace-nowrap">
          <button
            className="text-blue-600 hover:underline text-xs"
            onClick={() => openModal(item)}
          >
            See Details
          </button>
        </td>
        <td className="py-1.5 px-3 text-xs text-gray-800 border-t whitespace-nowrap">
          {item?.status === "registered" ? (
            <button
              className="text-white border border-primaryGreen bg-primaryGreen hover:bg-hoverGreen font-medium rounded text-xs px-2 py-0.5"
              onClick={() => onAssigned(item)}
            >
              Assign to me
            </button>
          ) : item?.status === "assigned" ? (
            <button
              className="text-white border border-primaryGreen bg-primaryGreen hover:bg-hoverGreen font-medium rounded text-xs px-2 py-0.5"
              onClick={() => manageComplaint(item)}
            >
              Complaint
            </button>
          ) : (
            <span className="text-xs text-green-600 font-medium">Closed</span>
          )}
        </td>
      </>
    );
  };

  const headers = getHeaders();

  return (
    <div className="py-6">
      <table className="min-w-full border-collapse bg-white rounded-lg shadow-md overflow-hidden">
        <thead className="bg-blue_primary">
          <tr>
            {headers?.map((header, index) => (
              <th
                key={index}
                className="py-3 px-4 text-left text-sm font-medium text-white uppercase tracking-wider"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => (
            <tr
              key={index}
              className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
            >
              {renderComplaintRow(item)}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal Component */}
      {isModalOpen && (
        <ModalComponent
          isOpen={isModalOpen}
          onClose={closeModal}
          complaintDetails={selectedComplaint} // Ensure the prop name matches
        />
      )}
    </div>
  );
};

export default ComplaintComponent;
